import { useToast } from '@lifebit-ai/lds'
import { useMutation, useQueryClient } from '@tanstack/react-query'

import { extractErrorMessage } from 'core/utils'
import { bulkAssignImportRequests } from 'services/import-requests'
import { ImportRequestQueryKeys } from 'services/import-requests/queryKeys'
import type { BulkAssignImportRequestsParams } from 'services/import-requests/types'
import { invalidateRequestActivityQueries } from 'services/request-activity/invalidateRequestActivityQueries'
import type { ApiErrorResponse } from 'services/types'

interface UseBulkAssignImportRequestsParams {
  onSuccess?: () => void
}

export const useBulkAssignImportRequests = ({ onSuccess }: UseBulkAssignImportRequestsParams = {}) => {
  const toast = useToast()
  const queryClient = useQueryClient()

  return useMutation<void, ApiErrorResponse, BulkAssignImportRequestsParams>({
    mutationFn: params => bulkAssignImportRequests(params),
    onSuccess: () => {
      toast({ message: 'Import requests assigned successfully' })
      queryClient.invalidateQueries({ queryKey: ImportRequestQueryKeys.All() })
      invalidateRequestActivityQueries(queryClient)
      onSuccess?.()
    },
    onError: error => {
      toast({ message: extractErrorMessage(error, 'Failed to assign import requests') })
    }
  })
}
